import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
var _excluded = ["className", "wrapperClassName", "content", "children", "size", "placement", "align", "offset"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { BaseTag } from './base-tag.js';
import styles from './sticky-tag.p.module.css.js';
var DEFAULT_OFFSET = 24;

var parsePlacement = function parsePlacement(placement) {
  var _context, _context2, _context3;

  var _placement$split$slic = _sliceInstanceProperty(_context = placement.split('-')).call(_context, 0, 2),
      _placement$split$slic2 = _slicedToArray(_placement$split$slic, 2),
      side = _placement$split$slic2[0],
      _placement$split$slic3 = _placement$split$slic2[1],
      justify = _placement$split$slic3 === void 0 ? 'center' : _placement$split$slic3;

  if (!_includesInstanceProperty(_context2 = ['top', 'right', 'bottom', 'left']).call(_context2, side)) {
    side = 'top';
  }

  if (!_includesInstanceProperty(_context3 = ['start', 'center', 'end']).call(_context3, justify)) {
    justify = 'end';
  }

  return {
    side: side,
    justify: justify
  };
};

var SIDE_STYLES = {
  top: styles.top,
  left: styles.left
};
var JUSTIFY_STYLES = {
  start: styles.start,
  end: styles.end
};
var ALIGN_STYLES = {
  top: styles.alignTop,
  middle: styles.alignMiddle
};
var SIZE_STYLES = {
  xs: styles.sizeXs,
  s: styles.sizeS,
  m: styles.sizeM,
  l: styles.sizeL
};
var OFFSET_STYLES = {
  16: styles.offset16,
  24: styles.offset24,
  32: styles.offset32
};
var StickyTag = /*#__PURE__*/React.forwardRef(function StickyTag(_ref, ref) {
  var className = _ref.className,
      wrapperClassName = _ref.wrapperClassName,
      content = _ref.content,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top-end' : _ref$placement,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'top' : _ref$align,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? DEFAULT_OFFSET : _ref$offset,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _parsePlacement = parsePlacement(placement),
      side = _parsePlacement.side,
      justify = _parsePlacement.justify;

  var offsetCn = offset in OFFSET_STYLES ? OFFSET_STYLES[offset] : OFFSET_STYLES[DEFAULT_OFFSET];
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.wrapper, wrapperClassName),
    "data-test": 'sticky-tag-wrapper'
  }, children, /*#__PURE__*/React.createElement(BaseTag, _objectSpread(_objectSpread({
    size: size,
    className: cn(styles.tag, className, SIZE_STYLES[size], JUSTIFY_STYLES[justify], SIDE_STYLES[side], ALIGN_STYLES[align], offsetCn),
    "data-test": 'sticky-tag'
  }, restProps), {}, {
    ref: ref
  }), content));
});
StickyTag.propTypes = {
  className: PropTypes.string,
  wrapperClassName: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  isUppercase: PropTypes.bool,
  placement: PropTypes.oneOf(['top-start', 'top-end', 'left-start', 'left-end']),
  align: PropTypes.oneOf(['top', 'middle']),
  size: PropTypes.oneOf(['l', 'm', 's', 'xs']),
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string
};
export { StickyTag };
